import type { LocaleCode } from '../types/site'

export function localized(
  values: Record<LocaleCode, string>,
  locale: LocaleCode,
  fallback: LocaleCode,
): string {
  return values[locale] ?? values[fallback] ?? Object.values(values)[0] ?? ''
}

